package com.shreyasjoshi.components

import org.jetbrains.compose.web.attributes.AttrsScope
import org.w3c.dom.Element

/**
 * Adds CSS class groups safely to a Compose HTML element.
 *
 * Compose HTML's [AttrsScope.classes] expects every argument to be one class token. Portfolio
 * styles are often grouped (for example, "bg-white text-slate-900"), so split each group before
 * passing the tokens to the DOM. Otherwise, DOMTokenList throws when a token contains spaces.
 */
fun <T : Element> AttrsScope<T>.classNames(vararg groups: String) {
    classes(
        *groups
            .flatMap { group -> group.split(' ') }
            .filter { token -> token.isNotBlank() }
            .toTypedArray()
    )
}
